export const InventoryChart = [
  {
    id: 'Ich1',
    value: 'Inventory/ Bar charts',
    text: 'Inventory/ Bar charts',
  },
  {
    id: 'Ich2',
    value: 'Inventory/ Month Historgrams charts',
    text: 'Inventory/ Month Historgrams charts',
  },
  {
    id: 'Ich3',
    value: 'Inventory/ Historgrams charts',
    text: 'Inventory/ Historgrams charts',
  },
  {
    id: 'Ich4',
    value: 'Inventory/ Pie charts',
    text: 'Inventory/ Pie charts',
  },
];
export const InventoryReportsChart = [
  {
    id: 'IRRCH1',
    value: 'Reports/ Bar charts',
    text: 'Reports/ Bar charts',
  },
  {
    id: 'IRRCH2',
    value: 'Reports/ Month Historgrams charts',
    text: 'Reports/ Month Historgrams charts',
  },
  {
    id: 'IRRCH3',
    value: 'Reports/ Historgrams charts',
    text: 'Reports/ Historgrams charts',
  },
  {
    id: 'IRRCH4',
    value: 'Reports/ Pie charts',
    text: 'Reports/ Pie charts',
  },
];

export const ProductionPlanningChart = [
  {
    id: 'PPBC1',
    value: 'Production Planning/ Bar charts',
    text: 'Production Planning/ Bar charts',
  },
  {
    id: 'PPBC2',
    value: 'Production Planning/ Month Historgrams charts',
    text: 'Production Planning/ Month Historgrams charts',
  },
  {
    id: 'PPBC3',
    value: 'Production Planning/ Historgrams charts',
    text: 'Production Planning/ Historgrams charts',
  },
  {
    id: 'PPBC4',
    value: 'Production Planning/ Pie charts',
    text: 'Production Planning/ Pie charts',
  },
];
export const OngoingActivitiesChart = [
  {
    id: 'ORCH1',
    value: 'OngoingActivities/ Bar charts',
    text: 'OngoingActivities/ Bar charts',
  },
  {
    id: 'ORCH2',
    value: 'OngoingActivities/ Month Historgrams charts',
    text: 'OngoingActivities/ Month Historgrams charts',
  },
  {
    id: 'ORCH3',
    value: 'OngoingActivities/ Historgrams charts',
    text: 'OngoingActivities/ Historgrams charts',
  },
  {
    id: 'ORCH4',
    value: 'OngoingActivities/ Pie charts',
    text: 'OngoingActivities/ Pie charts',
  },
];
